import {
    icon,
    LatLng,
    Map,
    Marker,
    marker,
    MarkerClusterGroup,
    TileLayer,
} from 'leaflet';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import 'leaflet.markercluster';
import parseAndTranslateOsmTimeString from '../util/parseAndTranslateOsmTimeString';

import 'leaflet-geosearch/dist/geosearch.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet/dist/leaflet.css';
import '../../css/lib/search-component.css';

const iconBasePath = `${
    import.meta.env.VITE_APP_URL
}/lib/search-component/icons`;

const sharedMarkerIconConf = {
    shadowUrl: `${iconBasePath}/marker-shadow.png`,
    iconSize: [25, 41],
    iconAnchor: [13, 42],
    popupAnchor: [0, -45],
    shadowSize: [41, 41],
    shadowAnchor: [13, 42],
};

const markerIconBlue = icon({
    ...sharedMarkerIconConf,
    iconUrl: `${iconBasePath}/marker.png`,
});

const markerIconRed = icon({
    ...sharedMarkerIconConf,
    iconUrl: `${iconBasePath}/marker-red.png`,
});

const markerIconYellow = icon({
    ...sharedMarkerIconConf,
    iconUrl: `${iconBasePath}/marker-yellow.png`,
});

let toggleButtonDoctors = true;
let toggleButtonGroups = true;

document.addEventListener('DOMContentLoaded', async () => {
    const anchor = document.getElementById('fff_search_component');
    if (!anchor) {
        console.error(
            'FFF search-component: anchor not found. please add \'<div id="fff_search_component"></div>\' in your markup.',
        );
    }
    const response = await fetch(import.meta.env.VITE_APP_URL + '/api/doctors');
    const doctors = await response.json();

    // to clear everything
    anchor.innerHTML = '';

    if (!anchor.getAttribute('style')) {
        anchor.style = 'height: 100%;';
    }

    // add controls above map
    const mapControls = createToggleButtons({
        onToggleDoctors: (e) => {
            toggleButtonDoctors = e.target.checked;
            repaintMap();
            // console.debug('toggle Docs');
        },
        onToggleGroups: (e) => {
            toggleButtonGroups = e.target.checked;
            repaintMap();
            // console.debug('toggle Groups');
        },
    });
    anchor.appendChild(mapControls);

    const mapAnchor = document.createElement('div');
    mapAnchor.classList.add('fff_map');

    anchor.appendChild(mapAnchor);

    const listAnchor = document.createElement('div');
    listAnchor.classList.add('fff_list_container');

    anchor.appendChild(listAnchor);

    const map = new Map(mapAnchor, {
        center: [51.163361111111, 10.447683333333],
        zoom: 6,
        maxZoom: 18,
        attributionControl: false,
    });

    map.addLayer(
        new TileLayer('https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png'),
    );

    map.addControl(
        new GeoSearchControl({
            style: 'bar',
            searchLabel: 'Stadt eingeben',
            provider: new OpenStreetMapProvider({
                params: {
                    'accept-language': 'de',
                    countrycodes: 'de',
                    addressdetails: 1,
                },
            }),
            marker: {
                icon: markerIconRed,
                draggable: false,
            },
            autoClose: true,
            keepResult: true,
        }),
    );

    map.on('locationfound', (e) => {
        marker(e.latlng, { icon: markerIconRed })
            .addTo(map)
            .bindPopup('Ihre erkannte Position.')
            .openPopup();
    });
    map.locate({ setView: true, maxZoom: 13 });

    let markerLayer = null;

    listAnchor.innerHTML = '';

    function repaintMap() {
        if (markerLayer) {
            map.removeLayer(markerLayer);
        }
        markerLayer = getMarkerLayer(doctors);
        map.addLayer(markerLayer);

        if (!document.querySelector('.fff_counter')) {
            const counterAnchor = document.createElement('div');
            counterAnchor.classList.add('fff_counter');
            counterAnchor.innerHTML = 'Bitte suchen oder zoomen.';
            listAnchor.appendChild(counterAnchor);
        }

        updateList(map);
    }

    repaintMap();

    map.on('zoomend', function () {
        listAnchor.append(updateList(map));
        // console.debug('zommed');
    });
    map.on('dragend', function () {
        listAnchor.append(updateList(map));
        // console.debug('drag end');
    });
});

function updateList(map) {
    const entriesInView = [];
    const mapCenter = map.getBounds().getCenter();

    // flatten markers array because of the nested marker groups
    getMarkersInView(map)
        .flat()
        .forEach((element) => {
            // filter out markers that have no doctor data object associated or it is already in the entriesInView array
            if (
                !element.doctorObj ||
                entriesInView.some((e) => e._leaflet_id === element._leaflet_id)
            ) {
                return;
            }

            element.distance = element.getLatLng().distanceTo(mapCenter);
            entriesInView.push(element);
        });

    const counterAnchor = document.querySelector('.fff_counter');
    const numEntries = entriesInView.length;
    let counterMsg = 'Es wurden ' + numEntries + ' Einträge gefunden.';
    if (numEntries === 0) {
        counterMsg = 'Es wurden keine Einträge gefunden, bitte herauszoomen.';
    } else if (numEntries === 1) {
        counterMsg = 'Es wurde ein Eintrag gefunden.';
    } else if (numEntries > 99) {
        counterMsg = 'Es wurden über 99 Einträge gefunden.';
    }
    counterAnchor.innerHTML = counterMsg;

    // sort by distance asc
    entriesInView.sort((a, b) => a.distance - b.distance);

    const fffListAnchor =
        document.querySelector('.fff_list') || document.createElement('div');
    fffListAnchor.classList.add('fff_list');
    fffListAnchor.innerHTML = '';

    if (numEntries > 99) {
        const entryAnchor = document.createElement('div');
        entryAnchor.classList.add('fff_entry');
        entryAnchor.innerHTML = 'Bitte Suche benutzen oder hineinzoomen.';
        entryAnchor.style.textAlign = 'center';
        fffListAnchor.appendChild(entryAnchor);
        // console.debug('nutz die suche');
    } else {
        entriesInView
            // filter out all entries that have no doctor data object
            .filter((e) => e.doctorObj)
            .forEach((e) => {
                const d = e.doctorObj;
                const entryAnchor = document.createElement('div');
                entryAnchor.classList.add('fff_entry');
                const checkIcon = `<img class="map_uro_check" src='${iconBasePath}/checkmark.png'></img>`;
                let treats = '';
                if (
                    d.type != 'supportgroup' &&
                    (d.treats_statutory_insured || d.treats_privately_insured)
                ) {
                    if (
                        !d.treats_statutory_insured &&
                        d.treats_privately_insured
                    ) {
                        treats = `<span class="map_uro_private">NUR PRIVATPATIENTEN</span>`;
                    } else if (
                        d.treats_statutory_insured &&
                        !d.treats_privately_insured
                    ) {
                        treats = `${checkIcon}<span style="padding-bottom:3px">Gesetzlich Versicherte (Krankenkassen)</span>`;
                    } else {
                        treats = `${checkIcon}<span style="padding-bottom:3px">Gesetzlich Versicherte (Krankenkassen)</span><br>${checkIcon}<span>Privatpatienten und Selbstzahler</span>`;
                    }
                }
                let oh =
                    '<div style="display: grid; grid-template-columns: auto auto; row-gap: 0.5rem; column-gap: 1rem;">';
                parseAndTranslateOsmTimeString(d.opening_hours).forEach(
                    (entry) => {
                        oh += `<div>${entry.day}</div><div>${entry.intervals}</div>`;
                    },
                );
                oh += '</div>';
                entryAnchor.innerHTML = `<details><summary><div class="fff_entry_top">
                    <div class="fff_distance fff_gi">
                        ${(e.distance / 1000).toFixed(1)} km
                        </div>
                            <div class="fff_middle fff_gi">${d.formalName}
                            <br>
                            ${d.doctors_office_name}</div>
                            <div class="fff_more fff_gi">
                                <img src="${iconBasePath}/chevron-down-24.svg">
                            </div>
                        </div>
                    </summary>

                    <div class="fff_more_info">
                    <div class="fff_more_info_center">

                    <h3 class="map_uro_headline">${
                        d.doctors_office_name ? d.doctors_office_name : ''
                    }</h3>
                    <h5 class="map_uro_headline">${d.formalName}</h5>
                    ${d.additional_info ? `${d.additional_info}<br/><br/>` : ''}
                    <hr class="map_uro_hr"><br>
                    ${d.street}<br/>${d.zip} ${d.city}<br/><br/>
                    ${
                        d.public_email
                            ? `Email: <a href="mailto:${d.public_email}">${d.public_email}</a><br/>`
                            : ''
                    }
                    ${
                        d.website
                            ? `Web: <a href="${
                                  d.website.startsWith('http')
                                      ? d.website
                                      : 'https://' + d.website
                              }" target="_blank">${d.website}</a><br/>`
                            : ''
                    }
                    ${
                        d.phone
                            ? `Telefon: <a href="tel:${d.phone}">${d.phone}</a><br/>`
                            : ''
                    }
                    ${d.fax ? `Fax: ${d.fax}<br/>` : ''}
                    <br/>
                    Routenplanung: <a href="https://maps.google.de/maps?q=${encodeURI(
                        `${d.doctors_office_name} ${d.street} ${d.zip} ${d.city}`,
                    )}" target="_blank">Google Maps</a><br/><br/>
                    </div>
                                <hr class="map_uro_hr"><br>
                    ${
                        d.opening_hours
                            ? `<u>Öffnungszeiten</u>:<br/><br/>${oh}<br/>`
                            : ''
                    }
                    ${d.notes ? `${d.notes}<br/><br/>` : ''}
                    ${treats ? `${treats}<br/><br/>` : ''}
                    </div>
                    </details>`;
                fffListAnchor.appendChild(entryAnchor);
            });
    }

    return fffListAnchor;
}

function getMarkersInView(map) {
    const markers = [];
    map.eachLayer((layer) => {
        if (
            !(layer instanceof L.Marker) ||
            !map.getBounds().contains(layer.getLatLng())
        ) {
            return;
        }
        if (layer._childCount > 0) {
            markers.push(layer.getAllChildMarkers());
        } else {
            markers.push(layer);
        }
    });

    return markers;
}

function getMarkerLayer(doctors) {
    const markers = new MarkerClusterGroup({});

    const checkIcon = `<img class="map_uro_check" src='${iconBasePath}/checkmark.png'></img>`;

    for (const d of doctors) {
        if (!d.geo_lat || !d.geo_long) {
            continue;
        }
        if (!toggleButtonDoctors && d.type === 'doctor') {
            continue;
        }
        if (!toggleButtonGroups && d.type === 'supportgroup') {
            continue;
        }
        let treats = '';
        if (
            d.type != 'supportgroup' &&
            (d.treats_statutory_insured || d.treats_privately_insured)
        ) {
            if (!d.treats_statutory_insured && d.treats_privately_insured) {
                treats = `<span class="map_uro_private">NUR PRIVATPATIENTEN</span>`;
            } else if (
                d.treats_statutory_insured &&
                !d.treats_privately_insured
            ) {
                treats = `${checkIcon}<span style="padding-bottom:3px">Gesetzlich Versicherte (Krankenkassen)</span>`;
            } else {
                treats = `${checkIcon}<span style="padding-bottom:3px">Gesetzlich Versicherte (Krankenkassen)</span><br>${checkIcon}<span>Privatpatienten und Selbstzahler</span>`;
            }
        }
        let oh;
        oh =
            '<div style="display: grid; grid-template-columns: auto auto; row-gap: 0.5rem; column-gap: 1rem;">';
        parseAndTranslateOsmTimeString(d.opening_hours).forEach((entry) => {
            oh += `<div>${entry.day}</div><div>${entry.intervals}</div>`;
        });
        oh += '</div>';

        const markerHTML = `<div>
<h2 class="map_uro_headline">${
            d.doctors_office_name ? d.doctors_office_name : ''
        }</h2>
<h4 class="map_uro_headline">${d.formalName}</h4>
${d.additional_info ? `${d.additional_info}<br/><br/>` : ''}
<hr class="map_uro_hr"><br>
${d.street}<br/>${d.zip} ${d.city}<br/><br/>
${
    d.public_email
        ? `Email: <a href="mailto:${d.public_email}">${d.public_email}</a><br/>`
        : ''
}
${
    d.website
        ? `Web: <a href="${
              d.website.startsWith('http') ? d.website : 'https://' + d.website
          }" target="_blank">${d.website}</a><br/>`
        : ''
}
${d.phone ? `Telefon: <a href="tel:${d.phone}">${d.phone}</a><br/>` : ''}
${d.fax ? `Fax: ${d.fax}<br/>` : ''}
<br/>
Routenplanung: <a href="https://maps.google.de/maps?q=${encodeURI(
            `${d.doctors_office_name} ${d.street} ${d.zip} ${d.city}`,
        )}" target="_blank">Google Maps</a><br/><br/>
            <hr class="map_uro_hr"><br>
${d.opening_hours ? `<u>Öffnungszeiten</u>:<br/><br/>${oh}<br/>` : ''}
${d.notes ? `${d.notes}<br/><br/>` : ''}
${treats ? `${treats}<br/><br/>` : ''}
</div>`;

        const icon =
            d.type === 'supportgroup' ? markerIconYellow : markerIconBlue;

        // create Marker
        const marker = new Marker(new LatLng(d.geo_lat, d.geo_long), {
            icon,
            title: `${d.doctors_office_name}   >>> Klicken für mehr Informationen`,
        });
        marker.bindPopup(markerHTML, {
            className: 'data_popup',
            autoPanPaddingTopLeft: [0, 75],
        });

        marker.doctorObj = d;

        markers.addLayer(marker);
    }
    return markers;
}

// create switch-buttons on top of the map to switch different groups on and off
function createToggleButtons({ onToggleDoctors, onToggleGroups }) {
    const mapControls = document.createElement('div');
    mapControls.style =
        'display:flex; justify-content: center; padding: 10px; font-family: Sans-Serif;';

    const switchDocs = document.createElement('div');
    switchDocs.style = 'padding-right: 30px; ';

    const switchInputDocs = document.createElement('input');
    switchInputDocs.classList.add('switch');
    switchInputDocs.type = 'checkbox';
    switchInputDocs.checked = 'checked';
    switchInputDocs.value = 'docs';
    switchInputDocs.name = 'docs';
    switchInputDocs.addEventListener('change', onToggleDoctors);

    const switchSpanDocs = document.createElement('span');
    switchSpanDocs.classList.add('slider', 'round');

    const switchLabelDocs = document.createElement('label');
    switchLabelDocs.classList.add('switch');

    const switchTextDocs = document.createElement('div');
    switchTextDocs.style = 'float: right; font-size:20px';
    switchTextDocs.innerHTML = `Urologien <img class="map_uro_icon" src='${iconBasePath}/marker.png'>`;

    switchLabelDocs.appendChild(switchInputDocs);
    switchLabelDocs.appendChild(switchSpanDocs);

    switchDocs.appendChild(switchLabelDocs);
    switchDocs.appendChild(switchTextDocs);

    // Groups
    const switchGroups = document.createElement('div');

    const switchInputGroups = document.createElement('input');
    switchInputGroups.classList.add('switch');
    switchInputGroups.type = 'checkbox';
    switchInputGroups.checked = 'checked';
    switchInputGroups.value = 'groups';
    switchInputGroups.name = 'groups';
    switchInputGroups.addEventListener('change', onToggleGroups);

    const switchSpanGroups = document.createElement('span');
    switchSpanGroups.classList.add('slider', 'round');

    const switchLabelGroups = document.createElement('label');
    switchLabelGroups.classList.add('switch');

    const switchTextGroups = document.createElement('div');
    switchTextGroups.style = 'float: right; font-size:20px';
    switchTextGroups.innerHTML = `Selbsthilfegruppen <img class="map_uro_icon" src="${iconBasePath}/marker-yellow.png">`;

    switchLabelGroups.appendChild(switchInputGroups);
    switchLabelGroups.appendChild(switchSpanGroups);

    switchGroups.appendChild(switchLabelGroups);
    switchGroups.appendChild(switchTextGroups);

    // Add both togglebuttons
    mapControls.appendChild(switchDocs);
    mapControls.appendChild(switchGroups);

    return mapControls;
}
